import React from 'react';
import { Page } from 'cccisd-laravel-report';
import style from './style.css';

const AnswerSummaryPage = ({ header, footer, children }) => {
    return (
        <Page>
            <div className={style.pageWrapper}>
                <div>
                    {!!header && !!header.url && (
                        <header className={style.header}>
                            <img src={header.url} alt="header" className={style.headerImg} />
                        </header>
                    )}
                    {children}
                </div>
                {!!footer && !!footer.url && (
                    <footer className={style.footer}>
                        <img src={footer.url} alt="footer" className={style.footerImg} />
                    </footer>
                )}
            </div>
        </Page>
    );
};

export default AnswerSummaryPage;
